<template>
  <div v-if="hadData && options.perPage <= noOfRecords">
    <v-row
      ><v-col cols="4"> <slot name="footer"></slot></v-col>
      <v-col cols="4"> <slot name="footer2"></slot></v-col>
      <v-col cols="4"> <slot name="footer3"></slot></v-col>
    </v-row>
    <div class="max-width">
      <v-row class="bg_1 ma-1 pa-0">
        <!-- <v-col class="ma-auto pl-5 pa-0 text-right d-none d-sm-flex">
          <label class="small d-sm-none d-md-flex"
            >Display {{ filterDatas.isrouteNewPage }}
          </label>
        </v-col> -->
        <v-col class="ma-2">
          <v-row>
            <v-select
              dense
              hide-details="auto"
              outlined
              :items="rowsPerPageItems"
              v-model="options.perPage"
              @change="onChangePageSize"
              :disabled="noOfRecords == 0"
              style="max-width: 100px"
            ></v-select>
            <label class="small ma-2 text-left d-sm-flex"
              >{{ recordFrom + ' - ' + recordTo + ' of ' + noOfRecords }}
            </label>
          </v-row>
        </v-col>
        <!-- <v-col class="ma-auto pa-0 text-left d-sm-flex">
          <label class="small"
            >{{ recordFrom + " - " + recordTo + " of " + noOfRecords }}
          </label></v-col
        > -->
        <v-col class="ma-auto pa-0 text-right">
          <v-pagination
            @input="onPaginationChange"
            v-model="options.page"
            :circle="true"
            :disabled="disabled"
            :length="options.total"
            :next-icon="nextIcon"
            :prev-icon="prevIcon"
            :page="selectedPage"
            :total-visible="totalVisiblePages"
          ></v-pagination>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  props: {
    // Request URL
    transferCreate: {
      type: Boolean,
      default: false,
    },
    filterAction: {
      type: Boolean,
      default: false,
    },
    paginationAction: {
      type: Boolean,
      default: true,
    },
    url: {
      type: String,
      default: '',
    },
    filter: {
      type: Object,
      default: {},
    },
    // Options for pagination
    // options: {
    //   type: Object,
    //   default: {
    //     descending: true,
    //     page: 1,
    //     rowsPerPage: 5,
    //     sortBy: "",
    //     totalItems: 0,
    //     rowsPerPageItems: [5, 10, 15],
    //     total: 0,
    //     page: 1,
    //   },
    // },
    // totalRecords: {
    //   type: Number,
    //   default: 0,
    // },
    // total: {
    //   type: Number,
    //   default: 0,
    // },
    value: {
      type: Number,
      default: 0,
    },
    // length: {
    //   type: Number,
    //   default: 0,
    // },
  },
  watch: {
    options: {
      handler(val) {
        this.$emit('paginationOptions', val);
      },
      deep: true,
    },
    filter: {
      handler(val) {
        // this.onChangePageSize();
        this.options.page = 1;
        this.fetchData();
      },
      deep: true,
    },
  },
  data() {
    return {
      hadData: false,
      pageSizes: [5, 10, 15],
      noOfRecords: 0,
      circle: false,
      disabled: false,
      // length: 0,
      nextIcon: 'mdi-arrow-right',
      nextIcons: ['mdi-chevron-right', 'mdi-arrow-right', 'mdi-menu-right'],
      prevIcon: 'mdi-arrow-left',
      prevIcons: ['mdi-chevron-left', 'mdi-arrow-left', 'mdi-menu-left'],
      //
      selectedPage: 1,
      totalVisiblePages: 10,
      selectedPageSize: 10,
      previousDatas: [],
      // recordFrom: 5,
      // recordTo: 10,

      options: {
        descending: true,
        page: 1,
        perPage: 15,
        rowsPerPage: 5,
        sortBy: 'fat',
        totalItems: 0,
        rowsPerPageItems: [5, 10, 20, 50],
        total: 0,
        // page: 1,
      },
    };
  },
  computed: {
    ...mapState(['pagination_settings']),
    ...mapState(['productpagesize']),
    ...mapState(['StockTransferWarehouse']),
    ...mapState(['productperpageItemsize']),
    ...mapState(['filterDatas']),
    ...mapState(['repoUrl']),
    ...mapState(['dialog1']),
    recordFrom: {
      get() {
        var from =
          this.noOfRecords < this.options.perPage
            ? this.noOfRecords
            : this.options.perPage * this.options.page - this.options.perPage;
        if (this.noOfRecords > 0 && from == 0) {
          return 1;
        } else {
          return from;
        }
      },
      set() {},
    },
    recordTo: {
      get() {
        var to =
          this.noOfRecords < this.options.perPage
            ? this.noOfRecords
            : this.options.perPage * this.options.page;
        if (to > this.noOfRecords) {
          return this.noOfRecords;
        }
        return to;
      },
      set() {},
    },
    rowsPerPageItems: {
      get() {
        var rowsPerPage = this.options.rowsPerPageItems
          ? this.options.rowsPerPageItems
          : [15, 20, 25, 30];

        if (this.noOfRecords < 5) {
          rowsPerPage = [1];
          this.options.perPage = 1;
        }
        var final = rowsPerPage.filter((item) => item <= this.noOfRecords);
        if (final[final.length - 1] != this.noOfRecords) {
          final[final.length] = this.noOfRecords;
        }
        return final;
      },
      set() {},
    },
  },
  created() {
    if (this.paginationAction == false) {
      this.$store.commit('UPDATE_IS_NEW_PAGE', true);
    } else {
      this.$store.commit('UPDATE_IS_NEW_PAGE', false);
    }

    if (this.url == this.repoUrl) {
      this.options.perPage = this.productperpageItemsize;
    }
    if (this.url != this.repoUrl && this.filterAction) {
      this.$store.commit('UPDATE_LOAD_URL', this.url);
      this.$store.commit('REMOVE_FILTERDATAS');
      this.$store.commit('UPDATE_PAGINATION_PAGE_SIZE', 15);
    }

    // this.GetPaginationSettings();
    // Fetch data
    //  this.$store.dispatch("SetProductSize", 1);
    this.fetchData();
  },
  mounted: function () {
    this.SetPaginationSettings(this.pagination_settings);
  },
  methods: {
    refreshData() {
      this.fetchData();
    },

    setExistingFilters() {
      if (this.paginationAction == true) {
        if (this.filter.brand == '' || this.filter.brand) {
          this.filter.brand = this.filterDatas.brand;
        }
        if (this.filter.category == '' || this.filter.category) {
          this.filter.category = this.filterDatas.category;
        }
        if (this.filter.supplier == '' || this.filter.supplier) {
          this.filter.supplier = this.filterDatas.supplier;
        }
        if (this.filter.status == '' || this.filter.status) {
          this.filter.status = this.filterDatas.status;
        }
        if (this.filter.shop == 1 || this.filter.shop) {
          this.filter.shop = this.transferCreate
            ? this.filter.shop
            : this.filterDatas.shop;
        }
        if (this.filter.customer == '' || this.filter.customer) {
          this.filter.customer = this.filterDatas.customer;
        }
        if (this.filter.biller == '' || this.filter.biller) {
          this.filter.biller = this.filterDatas.biller;
        }
        if (this.filter.product == '' || this.filter.product) {
          this.filter.product = this.filterDatas.product;
        }
        if (this.filter.saleType == '' || this.filter.saleType) {
          this.filter.saleType = this.filterDatas.saleType;
        }
        if (this.filter.customerType == '' || this.filter.customerType) {
          this.filter.customerType = this.filterDatas.customerType;
        }
        if (this.filter.warehouse == '' || this.filter.warehouse) {
          this.filter.warehouse = this.transferCreate
            ? this.StockTransferWarehouse
            : this.filterDatas.warehouse;
        }
        if (this.filter.purchasestatus == '' || this.filter.purchasestatus) {
          this.filter.purchasestatus = this.filterDatas.purchasestatus;
        }
        if (
          this.filter.purchaseOrderStatus == '' ||
          this.filter.purchaseOrderStatus
        ) {
          this.filter.purchaseOrderStatus =
            this.filterDatas.purchaseOrderstatus;
        }
        if (this.filter.paymentStatus == '' || this.filter.paymentStatus) {
          this.filter.paymentStatus = this.filterDatas.paymentStatus;
        }
        if (this.filter.amount == '' || this.filter.amount) {
          this.filter.amount = this.filterDatas.amount;
        }
        if (this.filter.transferStatus == '' || this.filter.transferStatus) {
          this.filter.transferStatus = this.filterDatas.transferStatus;
        }
        if (this.filter.paymenType == '' || this.filter.paymenType) {
          this.filter.paymenType = this.filterDatas.paymenType;
        }
        if (this.filter.type == '' || this.filter.type) {
          this.filter.type = this.filterDatas.type;
        }
        if (this.filter.expenseCategory == '' || this.filter.expenseCategory) {
          this.filter.expenseCategory = this.filterDatas.expenseCategory;
        }
        if (this.filter.expenseFor == '' || this.filter.expenseFor) {
          this.filter.expenseFor = this.filterDatas.expenseFor;
        }
        if (this.filter.start == '' || this.filter.start) {
          this.filter.start = this.filterDatas.start;
        }

        if (this.filter.end == '' || this.filter.end) {
          this.filter.end = this.filterDatas.end;
        }
        if (this.filter.search == '' || this.filter.search) {
          this.filter.search = this.filterDatas.search;
        }
        if (this.filter.startDate == '' || this.filter.startDate) {
          this.filter.startDate = this.filter.startDate;
        }
      }
    },
    async fetchData() {
      // if (this.$route.query.page && this.paginationAction) {
      //   this.options.page = this.productpagesize;
      // }

      await this.setExistingFilters();

      this.$store
        .dispatch('GetPaginationData', {
          url: this.url,
          // "?page=" +
          // this.options.page +
          // "&size=" +
          // this.options.rowsPerPage +
          // "&query=",
          data: this.options,
          params: {
            ...this.filter,
            page: this.options.page,
            size: this.productperpageItemsize
              ? this.productperpageItemsize
              : this.options.perPage,
            query: this.filter.search,
            querys: this.filter.query,
          },
        })
        .then((res) => {
          // this.Product = new ProductViewModel(res.data);
          // this.Product = res.data;
          if (res.data.meta) {
            if (this.paginationAction) {
              this.$store.commit('UPDATE_PAGESIZE', {
                val: res.data.meta.currentPage,
              });
            }
            this.noOfRecords = res.data.meta.totalItems;
            this.options.total = res.data.meta.lastPage;

            if (res.data.data.length != 0) this.hadData = true;
            else this.hadData = false;
            this.$emit('response', res.data.data);
          } else {
            this.noOfRecords = res.data.length;
            this.options.total = 1;
            this.$emit('response', []);

            this.$emit('responseData', res.data.data);
            this.$emit('responseDataBank', res.data);
            this.$emit('responseDataBalance', res.data.balance);
          }
        })
        .catch((err) => {
          this.$emit('response', []);
          // this.messages.push(err.data.title);
        });
    },
    onPaginationChange(value) {
      this.$emit('getPageNumber', value);
      this.changeSelectedPageRange();
      this.fetchData();
    },
    onChangePageSize(value) {
      this.$store.commit('UPDATE_PAGINATION_PAGE_SIZE', value);
      this.options.page = 1;
      this.selectedPage = 1;
      this.changeSelectedPageRange();
      this.fetchData();
      // this.$emit("input", value);
    },
    changeSelectedPageRange() {
      this.options.length = this.noOfRecords / this.selectedPageSize;
      this.recordFrom = this.selectedPageSize * (this.selectedPage - 1) + 1;
      this.recordTo =
        this.noOfRecords < 5
          ? this.noOfRecords
          : this.selectedPageSize * this.selectedPage;
    },
    // GetPaginationSettings() {
    //   this.$store
    //     .dispatch("GetPaginationSettings")
    //     .then((res) => {
    //       if (res.data && res.data[0]) {
    //         this.SetPaginationSettings(res.data[0]);
    //       }
    //     })
    //     .catch((err) => {
    //       this.messages = err.data.title;
    //       // this.$toast.error("Pagination settins error");
    //     });
    // },

    SetPaginationSettings(settings) {
      this.pageSizes = JSON.parse(settings.page_sizes);
      this.options.rowsPerPageItems = JSON.parse(settings.page_sizes);
      // this.selectedPageSize = settings.default_page_size;
      // this.noOfRecords = this.totalRecords;
      // this.length = this.noOfRecords / this.selectedPageSize;
      this.totalVisiblePages = settings.total_visible_pages;
      // this.options.perPage = settings.default_page_size
    },
  },
};
</script>

<style scoped>
hr {
  display: block;
  height: 1px;
  border: 0;
  border-top: 1px solid #ccc;
  margin: 1em 0;
  padding: 0;
}
</style>
